// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___1BIsj","m-signature-pad--body":"styles__m-signature-pad--body___1YWeB","m-signature-pad--footer":"styles__m-signature-pad--footer___2r1nE","description":"styles__description___NlKrJ","button":"styles__button___3IM-n","clear":"styles__clear___2y75j","save":"styles__save___3Bvum","m-signature-pad":"styles__m-signature-pad___3RR90","github":"styles__github___1KSmZ","labelContent":"styles__labelContent___1ARMD","infoIcon":"styles__infoIcon___12C-S","tooltipText":"styles__tooltipText___1vJ9P"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/holidayPromoSettings/styles.scss
// module id = fQMP
// module chunks = client